import React from 'react';
import { useTranslation } from 'react-i18next';
import { getIntlLocale } from '@/i18n/locales';

import { Card } from '@/components/ui/card';

export default function CheckoutTotalsCard({
  subtotal,
  serviceType,
  isDemoCheckout,
  demoDeliveryLine,
  deliveryLoading,
  deliveryQuote,
  markerPosition,
  tip,
  total,
  primaryColor,
}) {
  const { t, i18n } = useTranslation();
  const intl = getIntlLocale(String(i18n.language || 'es').slice(0, 2));

  return (
    <Card className="p-6 bg-secondary/50">
      <div className="space-y-3">
        <div className="flex justify-between">
          <span>{t('checkout.subtotal')}</span>
          <span className="font-semibold">${subtotal.toLocaleString(intl)}</span>
        </div>
        {serviceType === 'delivery' && (
          <div className="flex justify-between">
            <span>{t('checkout.deliveryFee')}</span>
            <span className="font-semibold">
              {isDemoCheckout
                ? `$${demoDeliveryLine.toLocaleString(intl)}`
                : deliveryLoading
                  ? t('checkout.calculating')
                  : typeof deliveryQuote?.delivery_fee === 'number'
                    ? `$${deliveryQuote.delivery_fee.toLocaleString(intl)}`
                    : markerPosition
                      ? t('checkout.toCalculate')
                      : t('common.emDash')}
            </span>
          </div>
        )}
        {tip > 0 && (
          <div className="flex justify-between">
            <span>{t('checkout.tip')}</span>
            <span className="font-semibold">${tip.toLocaleString(intl)}</span>
          </div>
        )}
        <div className="flex justify-between text-2xl font-bold pt-3 border-t">
          <span>{t('checkout.total')}</span>
          <span style={{ color: primaryColor }}>${total.toLocaleString(intl)}</span>
        </div>
      </div>
    </Card>
  );
}
